/**
 *
 * @param value - The boolean value to convert to a string.
 * @description Converts a boolean value to its string representation.
 * @example 'true' for true and 'false' for false.
 * @returns {string} - Returns 'true' or 'false' based on the boolean value.
 */
export const booleanToString = (value: boolean) => {
    return value ? 'true' : 'false';
};

/**
 * @param value - The string value to convert to a boolean.
 * @description Converts a string representation of a boolean to its actual boolean value.
 * @example 'true' to true and any other string to false.
 * @returns {boolean} - Returns true if the string is 'true', otherwise false.
 */
export const stringToBoolean = (value: string): boolean => {
    return value === 'true' ? true : false;
};
